import { useLocation } from 'react-router-dom'
import {
  computeBackgroundLocation,
  findRouteBackgroundLocation,
} from 'src/navigation/backgroundLocationCalculation'
import {
  NavigationLocation,
  NavigationLocationState,
} from 'src/navigation/modalBackgrounds'

// Re-exported so consumers can import the whole convention from one module;
// the pure (react-router-dom-free) definitions live in
// `backgroundLocationCalculation.ts`.
export { computeBackgroundLocation, findRouteBackgroundLocation }

export const useBackgroundLocation = (): NavigationLocation => {
  const location = useLocation<NavigationLocationState | undefined>()

  return computeBackgroundLocation(location)
}
